import HttpClient from "../http_client";
import {StringMap} from "../../utils/utils";
import {getLocale} from "../../helpers/locale";
import {GeoLocationResponse} from "../../types/geolocation";

export interface ParamsSearchRequest {
    cc_format?:string
}
export default class WoosmapGeolocationApi {
    private httpClient: HttpClient;

    constructor(httpClient: HttpClient) {
        this.httpClient = httpClient;
    }
    getCurrentPosition({...params}: ParamsSearchRequest): Promise<GeoLocationResponse> {
        const apiPath = "/geolocation/position/";
        const options: RequestInit = {
            method: "GET",
            headers: {
                Accept: "application/json",
            },
        };
        return this.httpClient
            .call(apiPath, params as StringMap, options)
            .then((response: Response) => {
                return response.json();
            });
    }
    protected processCurrentPosition(response: Response): Promise<GeoLocationResponse> {
        const status = response.status;
        if (status === 200) {
            return response.json().then((data: GeoLocationResponse) => {
                return data;
            });
        } else if (status === 401) {
            throw new Error(getLocale().errors.apiErrors["401"]);
        } else if (status === 403) {
            throw new Error(getLocale().errors.apiErrors["403"]);
        } else if (status === 429) {
            throw new Error(getLocale().errors.apiErrors["429"]);
        } else if (status === 500) {
            throw new Error(getLocale().errors.apiErrors["500"]);
        } else if (status !== 200 && status !== 204) {
            throw new Error(getLocale().errors.apiErrors.other);
        }
        return Promise.resolve<GeoLocationResponse>(null as any);
    }
}